export const statusOptions = [
  { value: 'all', label: 'Todos los estados' },
  { value: 'CREATED', label: 'Creado' },
  { value: 'PENDING_TO_ARRIVE', label: 'Pendiente de arribo' },
  { value: 'ARRIVED', label: 'Arribado' },
  { value: 'CANCELLED', label: 'Cancelado' },
]

// Función para obtener el label en español de un estado
export const getStatusLabel = (status: string): string => {
  const option = statusOptions.find((opt) => opt.value === status)
  return option ? option.label : status
}
